// @ts-nocheck
import React from 'react';
import { Shield, Star, CheckCircle, Clock } from 'lucide-react';

interface TrustSectionProps {
  sectionId: string;
  sectionData?: any[];
  [key: string]: any;
}

const features = [
  { icon: Shield, title: "Verified Providers", desc: "Background checks, licensing, and insurance verification for all organizations." },
  { icon: Star, title: "Trusted Reviews & Ratings", desc: "Pick the right activity based on real ratings and reviews from other parents." },
  { icon: CheckCircle, title: "Instant Confirmation", desc: "Book with confidence knowing your spot is secured immediately." },
];

const badges = [
  { icon: CheckCircle, label: "Background Checks", color: "bg-blue-50 dark:bg-blue-950/30 border-blue-200 dark:border-blue-900/30" },
  { icon: Shield, label: "Licensed & Insured", color: "bg-emerald-50 dark:bg-emerald-950/30 border-emerald-200 dark:border-emerald-900/30" },
  { icon: Star, label: "Parent Reviews", color: "bg-amber-50 dark:bg-amber-950/30 border-amber-200 dark:border-amber-900/30" },
  { icon: Clock, label: "Years of Experience", color: "bg-violet-50 dark:bg-violet-950/30 border-violet-200 dark:border-violet-900/30" },
];

const TrustSection: React.FC<TrustSectionProps> = ({ sectionId, sectionData, ...extraProps }) => {
  return (
    <section id={sectionId} className="container px-4 md:px-6 py-16 lg:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start max-w-6xl mx-auto">
        <div>
          <p className="font-bold text-destructive text-sm tracking-wide uppercase">Secure Guard</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mt-4 max-w-lg">
            Trust and safety features for your protection
          </h2>
          <ul className="flex flex-col gap-8 pt-8 lg:pt-12">
            {features.map((item, idx) => (
              <li key={idx} className="relative flex items-start gap-4">
                <div className="flex items-center justify-center rounded-full bg-primary p-3 text-white shrink-0">
                  <item.icon className="h-5 w-5" />
                  {idx < 2 && (
                    <div className="absolute top-14 left-6 h-12 w-0.5 bg-gradient-to-b from-primary/60 to-transparent" />
                  )}
                </div>
                <div>
                  <h5 className="text-lg font-bold">{item.title}</h5>
                  <p className="max-w-md py-2 text-muted-foreground font-medium">{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="relative flex items-center justify-center">
          <div className="w-full grid grid-cols-2 gap-4">
            {badges.map((item) => (
              <div
                key={item.label}
                className={`flex flex-col items-center gap-3 p-6 border rounded-2xl ${item.color} box-shadow-card hover-elevate relative overflow-visible`}
              >
                <item.icon className="h-8 w-8 text-primary" />
                <span className="text-sm font-semibold text-center">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
